export default __webpack_public_path__ + "static/media/video_play_large@3x.9d9d1acb.png";